import React from "react";
import { Button, Typography, Container } from "@material-ui/core";
import useStyles from "../styles";
import { useHistory } from "react-router-dom";

const NoAlreadyRegistered = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <div className={classes.bodyStyle}>
      <Container maxWidth="md">
        <Typography
          className={classes.typographyStyle}
          variant="h5"
          align="center"
          gutterBottom
        >
          Denne e-postadressen er allerede registrert for messen Sign, Print &
          Promotion 2027!
        </Typography>
        <Typography
          className={classes.typographyStyle}
          variant="body1"
          align="center"
          gutterBottom
        >
          Vær oppmerksom på at du ikke kan registrere flere besøkende til samme
          e-postadresse.
        </Typography>
        <Typography
          className={classes.typographyStyle}
          align="center"
          gutterBottom
        >
          <Button
            onClick={() => {
              history.push("/no/register");
            }}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            Prøv igen
          </Button>
          <Button href="https://sipp.no/" variant="outlined" color="primary">
            Till messen
          </Button>
        </Typography>
      </Container>
    </div>
  );
};

export default NoAlreadyRegistered;
